import { useCallback } from 'react'

// utils
import {
  getErc721Balance,
  getNftHelperContract,
} from '../../sushi/utils'
import { compare } from '../../utils/func'
import { userNftAddress } from '../../userType/userNftAddress'
// hooks
import { useActiveWeb3React } from '../'
import useUserAsks from '../nft/useUserAsks'
import useUserBids from '../nft/useUserBids'
import useUserStakes from '../nft/useUserStakes'
import useYam from '../bakery/useYam'

const useMyArtworks = (type: string, nftType?: string, nftType_V2?: string) => {
  const { account } = useActiveWeb3React()
  const sushi = useYam()
  const nftHelper = getNftHelperContract(sushi)
  const nftAddress = userNftAddress(sushi, type)

  // staking
  const userStakes = useUserStakes(nftType)
  const userStakes2 = useUserStakes(nftType_V2)
  const userBids = useUserBids(type)
  const userAsks = useUserAsks(type)

  const getMyArtworks = useCallback(async (noNeed?: boolean) => {
    if (account) {
      const allStakingDishes = await userStakes() // 质押
      const allStakingDishes2 = await userStakes2() // 质押2
      const allMyBids= await userBids() // 参与竞价
      const allMyAsks= await userAsks() // 挂单
      const allMyArtworks = await getErc721Balance(nftHelper, nftAddress, account) // 钱包

      const asks: any[] = allMyAsks.map((d: any[]) => {
        return d[0]
      })

      const bids: any[] = allMyBids.map((d: any[]) => {
        return d[0]
      })

      // Deduplication
      const asksSet = new Set()
      asks.forEach((d) => {
        asksSet.add(d.toString())
      })
      bids.forEach((d) => {
        asksSet.add(d.toString())
      })
      const arr = [
        ...allStakingDishes,
        ...allStakingDishes2,
        ...asks,
        ...bids
      ]
      if (!noNeed) {
        arr.push(
          ...(allMyArtworks.filter((d: any) => {
            return !asksSet.has(d.toString())
          }))
        )
      }
      return arr.sort(compare('tokenId'))
    }
    return []
  }, [account, userBids, userStakes, userAsks])

  return getMyArtworks
}

export default useMyArtworks